<template>
  <div>
    <div class="l-main-content">
      <div class="p-project-edit p-project-edit--readonly">
        <div class="c-title">
          <div class="c-title__text u-fs24">{{ data.title }}</div>
        </div>
        <ul class="p-project-edit-list">
          <!-- AccessToken -->
          <li class="p-project-edit-list__item">
            <div class="p-project-edit-list__title">AccessToken</div>
            <div class="p-project-edit-list__text">
              {{ data.accessToken }}
            </div>
          </li>
          <!-- /AccessToken -->
          <!-- スクリプトタグ -->
          <li class="p-project-edit-list__item">
            <div class="c-input">
              <div class="c-input__title u-w190">プレオプトイン対応</div>
              <div class="c-radio u-w680">
                <ul class="c-radio-list">
                  <li class="c-radio-list__item" style="margin-bottom: 0;">
                    <label class="c-radio__label">
                      <input
                        v-model="isPreoptinChecked"
                        type="radio"
                        name="isPreoptinChecked"
                        :value="0"
                        @change="onScriptTagSettingChange"
                      />
                      <div class="c-radio__item">
                        <div class="c-radio__box"></div>
                        <div class="c-radio__box-label">なし</div>
                      </div>
                    </label>
                  </li>
                  <li class="c-radio-list__item" style="margin-bottom: 0;">
                    <label class="c-radio__label">
                      <input
                        v-model="isPreoptinChecked"
                        type="radio"
                        name="isPreoptinChecked"
                        :value="1"
                        @change="onScriptTagSettingChange"
                      />
                      <div class="c-radio__item">
                        <div class="c-radio__box"></div>
                        <div class="c-radio__box-label">全てのブラウザ</div>
                      </div>
                    </label>
                  </li>
                  <li class="c-radio-list__item" style="margin-top: 0; margin-bottom: 0;">
                    <label class="c-radio__label">
                      <input
                        v-model="isPreoptinChecked"
                        type="radio"
                        name="isPreoptinChecked"
                        :value="2"
                        @change="onScriptTagSettingChange"
                      />
                      <div class="c-radio__item">
                        <div class="c-radio__box"></div>
                        <div class="c-radio__box-label">必須ブラウザのみ</div>
                      </div>
                    </label>
                    <div
                      v-tooltip="'Firefox、Edge、Safariなど、通知許可にプレオプトインが必須なブラウザにのみ表示します。'"
                      style="
                        height: 16px;
                        margin-top: 3px;
                        margin-left: 2px;
                        width: 16px;
                      "
                    >
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        style="height: 16px;"
                      >
                        <use xlink:href="/assets/img/sprite.svg#question" style="fill: #999; cursor: pointer;" />
                      </svg>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="c-input__text c-input__text--spec c-text">
              <p>※「プレオプトイン対応」のマニュアルは<a style="text-decoration: underline;" target="_blank" href="https://manual.webpush.jp/posts/feature-optindialog">こちら</a></p>
            </div>
          </li>
          <li class="p-project-edit-list__item">
            <div class="c-input">
              <div class="c-input__title u-w190">iOS対応</div>
              <div class="c-radio u-w680">
                <ul class="c-radio-list">
                  <li class="c-radio-list__item" style="margin-bottom: 0;">
                    <label class="c-radio__label">
                      <input
                        v-model="isIosChecked"
                        type="radio"
                        name="isIosChecked"
                        :value="false"
                        @change="onScriptTagSettingChange"
                      />
                      <div class="c-radio__item">
                        <div class="c-radio__box"></div>
                        <div class="c-radio__box-label">なし</div>
                      </div>
                    </label>
                  </li>
                  <li class="c-radio-list__item" style="margin-top: 0; margin-bottom: 0">
                    <label class="c-radio__label">
                      <input
                        v-model="isIosChecked"
                        type="radio"
                        name="isIosChecked"
                        :value="true"
                        @change="onScriptTagSettingChange"
                      />
                      <div class="c-radio__item">
                        <div class="c-radio__box"></div>
                        <div class="c-radio__box-label">あり</div>
                      </div>
                    </label>
                  </li>
                </ul>
              </div>
            </div>
            <div class="c-input__text c-input__text--spec c-text">
              <p>※「iOS対応」のマニュアルは<a style="text-decoration: underline;" target="_blank" href="https://manual.webpush.jp/posts/feature-ios">こちら</a>。また、iOS対応するにはPWA設定も必要です。詳しくは<a style="text-decoration: underline;" target="_blank" :href="'/coins-admin/project/pwa/' + serviceId">こちら</a></p>
            </div>
          </li>
          <li class="p-project-edit-list__item">
            <div class="c-input">
              <div class="c-input__title u-w190">ブロック解除バー対応</div>
              <div class="c-radio u-w680">
                <ul class="c-radio-list">
                  <li class="c-radio-list__item" style="margin-bottom: 0;">
                    <label class="c-radio__label">
                      <input
                        v-model="isBlockChecked"
                        type="radio"
                        name="isBlockChecked"
                        :value="false"
                        @change="onScriptTagSettingChange"
                      />
                      <div class="c-radio__item">
                        <div class="c-radio__box"></div>
                        <div class="c-radio__box-label">なし</div>
                      </div>
                    </label>
                  </li>
                  <li class="c-radio-list__item" style="margin-top: 0; margin-bottom: 0">
                    <label class="c-radio__label">
                      <input
                        v-model="isBlockChecked"
                        type="radio"
                        name="isBlockChecked"
                        :value="true"
                        @change="onScriptTagSettingChange"
                      />
                      <div class="c-radio__item">
                        <div class="c-radio__box"></div>
                        <div class="c-radio__box-label">あり</div>
                      </div>
                    </label>
                  </li>
                </ul>
              </div>
            </div>
            <div class="c-input__text c-input__text--spec c-text">
              <p>※「ブロック解除バー対応」のマニュアルは<a style="text-decoration: underline;" target="_blank" href="https://manual.webpush.jp/posts/feature-unblockingrequest">こちら</a></p>
            </div>
          </li>
          <li v-if="useReminder" class="p-project-edit-list__item">
            <div class="c-input">
              <div class="c-input__title u-w190">リマインダー配信</div>
              <div class="c-radio u-w680">
                <ul class="c-radio-list">
                  <li class="c-radio-list__item" style="margin-bottom: 0;">
                    <label class="c-radio__label">
                      <input
                        v-model="isReminderChecked"
                        type="radio"
                        name="isReminderChecked"
                        :value="false"
                        @change="onScriptTagSettingChange"
                      />
                      <div class="c-radio__item">
                        <div class="c-radio__box"></div>
                        <div class="c-radio__box-label">なし</div>
                      </div>
                    </label>
                  </li>
                  <li class="c-radio-list__item" style="margin-top: 0; margin-bottom: 0">
                    <label class="c-radio__label">
                      <input
                        v-model="isReminderChecked"
                        type="radio"
                        name="isReminderChecked"
                        :value="true"
                        @change="onScriptTagSettingChange"
                      />
                      <div class="c-radio__item">
                        <div class="c-radio__box"></div>
                        <div class="c-radio__box-label">あり</div>
                      </div>
                    </label>
                  </li>
                </ul>
              </div>
            </div>
            <div class="c-input__text c-input__text--spec c-text">
              <p>※「リマインダー配信」のマニュアルは<a style="text-decoration: underline;" target="_blank" href="https://manual.webpush.jp/posts/reminder-overview">こちら</a></p>
            </div>
          </li>
          <li class="p-project-edit-list__item">
            <div class="c-textarea">
              <div class="c-textarea__title">スクリプトタグ</div>
              <textarea
                v-model="data.scriptTag"
                v-tooltip.top-start="{
                  content: isChanged ? '設定を更新しました。新しいスクリプトタグをページに設置して、変更を反映してください。' : '',
                  shown: isChanged,
                }"
                style="margin-left: auto"
                class="c-textarea__item u-w630 u-h126"
                :name="data.copyId"
                :style="{ backgroundColor: isChanged ? '#d7eff5' : 'inherit' }"
                readonly
              ></textarea>
              <div class="c-textarea__text c-textarea__text--spec c-text">
                <p>※タグは各種タグマネージャーで設置可能ですので、お使いのタグマネージャー</p>
                <p>（GoogleTagManagerなど）でも設置可能です。詳しい導入方法は<a style="text-decoration: underline;" target="_blank" href="https://manual.webpush.jp/posts/initialsetting-tag-gtm">こちら</a></p>
              </div>
              <button
                class="c-btn c-btn--circle"
                type="button"
                name="clip"
                value="add-user"
                @click="onClipClick($event)"
              >
                <div
                  v-tooltip="{
                    content: isCopied
                      ? 'コピーしました'
                      : 'クリップボードにコピー',
                    hideTriggers: (triggers) => triggers.filter((trigger) => trigger !== 'click'),
                  }"
                  @click="toggleCopyText"
                >
                  <div class="c-icon-circle c-icon-circle--gray-2 u-wh40">
                    <div class="c-icon-circle__item c-icon-circle__item--white c-icon__item--alpha70 u-wh20">
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <use xlink:href="/assets/img/sprite.svg#clipboard" />
                      </svg>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </li>
          <!-- /スクリプトタグ -->
          <!-- AccessToken -->
          <li v-show="data.useServiceworker || data.useManifest" class="p-project-edit-list__item">
            <div class="p-project-edit-list__title p-project-edit-list__title--module">
              ブラウザモジュール
            </div>
            <div class="p-project-edit-list__btns">
              <a v-show="data.useServiceworker" class="c-btn c-btn--gray" @click="onServiceWorkerClick">
                <div class="c-icon c-icon--white u-wh24 c-icon--alpha50">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <use xlink:href="/assets/img/sprite.svg#download" />
                  </svg>
                </div>
                <p class="c-btn__text">serviceworker.js</p>
              </a>
              <a v-show="data.useManifest" class="c-btn c-btn--gray" @click="onManifestClick">
                <div class="c-icon c-icon--white u-wh24 c-icon--alpha50">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <use xlink:href="/assets/img/sprite.svg#download" />
                  </svg>
                </div>
                <p class="c-btn__text">manifest.json</p>
              </a>
              <ul class="p-project-edit-suppl-list">
                <li class="p-project-edit-suppl-list__item c-text">
                  ※ルートディレクトリに設置が出来ない場合はタグの記載を変更する必要があります。くわしくは
                  <a style="text-decoration: underline;" target="_blank" href="https://manual.webpush.jp/posts/initialsetting-serviceworker">こちら</a>
                </li>
              </ul>
            </div>
          </li>
          <!-- /AccessToken -->
        </ul>
        <!-- /入力 | 選択リスト -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from '../../funcs/store.js';
export default {
  props: {
    title: String,
    accessToken: String,
    scriptTag: String,
    copyId: String,
    useServiceworker: Boolean,
    useManifest: Boolean,
    updateScriptTagSettings: Function
  },
  emits: ["settings-change"],
  data() {
    return {
      data: {
        title: this.title,
        accessToken: this.accessToken,
        scriptTag: this.scriptTag,
        copyId: this.copyId,
        useServiceworker: this.useServiceworker,
        useManifest: this.useManifest,
      },
      isIosChecked: false,
      isPreoptinChecked: 0,
      isBlockChecked: false,
      isReminderChecked: false,
      serviceId: null,
      isCopied: false,
      isChanged: false,
    }
  },
  computed: {
    useReminder() {
      return store.getUseReminder();
    },
  },
  mounted() {
    this.getScriptTagSetting();
  },
  methods: {
    onClipClick: function(event) {
      // ブラウザデフォルトイベントを停止
      event.preventDefault();

      // 埋め込みタグの文字列をコピー
      let text = $(`textarea[name="${this.data.copyId}"]`).prop('value');

      this.$copyText(text).then(function (_e) {
      }, function (_e) {
      })
    },
    onServiceWorkerClick: function(event) {
      event.preventDefault();
      location.href = '/coins-admin/onboarding/download?filename=serviceworker.js';
    },
    onManifestClick: function(event) {
      event.preventDefault();
      location.href = '/coins-admin/onboarding/download?filename=manifest.json';
    },
    onScriptTagSettingChange() {
      this.isChanged = true;
      this.updateScriptTagSettings();
      const data = {
        ios: this.isIosChecked,
        preoptin: this.isPreoptinChecked,
        block: this.isBlockChecked,
        reminder: this.isReminderChecked,
      }
      this.$emit('settings-change', data);
      axios.post('/api/script-tag-setting/save', data)
        .then(_res => {})
        .catch(_e => {});
    },
    getScriptTagSetting() {
      this.serviceId = window.location.href.split('/').pop();

      axios.get('/api/script-tag-setting/get')
        .then(res => {
          this.isIosChecked = res.data.ios ?? false;
          this.isBlockChecked = res.data.block ?? false;
          this.isReminderChecked = res.data.reminder ?? false;
          // 旧仕様との互換性を保つため、preoptinのみ異なる処理を行う
          if (typeof res.data.preoptin === "boolean") {
            this.isPreoptinChecked =
              res.data.preoptin && res.data.requiredBrowser
                ? 2
                : res.data.preoptin && !res.data.requiredBrowser
                  ? 1
                  : 0;
          } else {
            this.isPreoptinChecked = res.data.preoptin ?? 0;
          }
          this.updateScriptTagSettings();
          this.$emit('settings-change', {
            ios: this.isIosChecked,
            preoptin: this.isPreoptinChecked,
            block: this.isBlockChecked,
            reminder: this.isReminderChecked,
          });
        })
        .catch(_e => {});
    },
    toggleCopyText: function () {
      this.isCopied = true;
      setTimeout(() => {
        this.isCopied = false;
      }, 2000);
    },
  },
};
</script>
